import { axios } from "@/plugins/axios";

function getMy21Content() {
    return axios.post("?Mode=MeinServicebereich&Function=GetMy21Content");
}

function emailMy21Feedback(email, message) {
    return axios.post(
        "?Mode=General&Function=EmailMy21Feedback",
        "email=" + email + "&message=" + message
    );
}

function emailMy21Fragebogen(email, message) {
    return axios.post(
        "?Mode=General&Function=EmailMy21Fragebogen",
        "email=" + email + "&message=" + message
    );
}

export { getMy21Content, emailMy21Feedback, emailMy21Fragebogen };
